import React, { useState, useEffect, useRef } from "react";
import { Fieldset } from "primereact/fieldset";
import { previewPdfOnSamePage } from "../../commonUtils";

export default function RBBLiframe(props) {
  const {
    className,
    showToolBar = true,
    height = "600px",
    width = "100%",
    authKey = undefined,
    reportGuid = undefined
  } = props;
  const [pdfUrl, setPdfUrl] = useState("");

  useEffect(() => {
    runPreview();
  }, []);

  const runPreview = async () => {
    setPdfUrl(await previewPdfOnSamePage(reportGuid, authKey));
  };

  const pdfViewerParams = `navpanes=0&scrollbar=0${
    showToolBar ? "" : "&toolbar=0"
  }`;

  return (
    <div>
      {pdfUrl && (
        <iframe
          src={`${pdfUrl}#${pdfViewerParams}`}
          title="Annual report PDF preview"
          {...(className ? { className } : {})}
          height={height}
          width={width}
        />
      )}
    </div>
  );
}
